import './styles/index.scss'
import './styles/variables.module.scss';
import './styles/font.scss'
import './styles/font1.scss'

import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'

import store from './store'
import MetaInfo from 'vue-meta-info'

Vue.use(ElementUI)
Vue.use(MetaInfo)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
      document.dispatchEvent(new Event('render-event')); // 与配置中的事件名一致

      var _hmt = _hmt || [];
      (function() {
          var hm = document.createElement("script");
          hm.src = "https://hm.baidu.com/hm.js?7d14dca1db399d5a219e586ad0870859";
          var s = document.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(hm, s);
      })();
  }
}).$mount('#app')
